import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Card, Section, TH, TD, Empty, Badge } from "../components/ui";
import { Boxes, CheckCircle2, ArrowRight } from "lucide-react";

export default function HoldedCompanies() {
  const [companies, setCompanies] = useState([]);
  useEffect(() => { api.get("/companies").then(({ data }) => setCompanies(data)); }, []);

  return (
    <div className="space-y-6">
      <Section
        title={<span className="flex items-center gap-2"><Boxes size={20} /> Sync Holded</span>}
        subtitle="Sincronizzazione Zoho Invoice → Holded. Per attivare il modulo per una società, vai nel suo dettaglio e abilita 'Holded target'."
      >
        <Card className="overflow-hidden">
          <table className="w-full">
            <thead className="bg-surface-hover/50 border-b border-border-default">
              <tr><TH>Società</TH><TH>Holded abilitato</TH><TH>Approvazione automatica</TH><TH></TH></tr>
            </thead>
            <tbody>
              {companies.map((c) => (
                <tr key={c.id} className="border-b border-border-divider">
                  <TD className="font-medium">{c.name}</TD>
                  <TD>
                    {c.has_holded_target
                      ? <Badge tone="success"><CheckCircle2 size={11} className="mr-1" />sì</Badge>
                      : <Badge>—</Badge>}
                  </TD>
                  <TD>{c.holded_auto_approve_invoices ? <Badge tone="warning">sì</Badge> : <Badge>no (bozza)</Badge>}</TD>
                  <TD>
                    <Link to={`/holded/${c.id}`}
                          className="text-ink hover:underline text-sm inline-flex items-center gap-1"
                          data-testid={`open-holded-${c.id}`}>
                      {c.has_holded_target ? "Apri" : "Configura"} <ArrowRight size={13} />
                    </Link>
                  </TD>
                </tr>
              ))}
              {companies.length === 0 && <tr><td colSpan={4}><Empty>Nessuna società.</Empty></td></tr>}
            </tbody>
          </table>
        </Card>
      </Section>
    </div>
  );
}
